import React from 'react';

interface CustomToggleProps {
  value: string | boolean;
  onChange: (value: string | boolean) => void;
  options: { value: string | boolean; label: string; icon?: string }[];
  isMobile?: boolean;
}

const CustomToggle: React.FC<CustomToggleProps> = React.memo(
  ({ value, onChange, options, isMobile }) => {
    return (
      <div className="flex w-full flex-row justify-between gap-x-1 rounded-full border-[1px] border-[#EAECF0] bg-primarybg p-[2px]">
        <div
          onClick={() => onChange(options[0].value)}
          className={`flex h-[44px] w-[272px] flex-row items-center justify-center space-x-1 rounded-full hover:cursor-pointer ${value === options[0].value ? 'bg-white text-primary' : 'text-graysecondary'} align-middle`}
        >
          {options[0].icon && options[1].icon && (
            <img
              src={options[0].icon}
              alt={`${options[0].value}-svg`}
              className={`h-[20px] w-[20px] ${value === options[0].value ? 'text-primary' : 'text-graysecondary'}`}
            />
          )}{' '}
          <p
            className={`text-center ${isMobile ? 'text-[14px]' : 'text-[16px]'}`}
          >
            {options[0].label}
          </p>
        </div>
        <div
          onClick={() => onChange(options[1].value)}
          className={`flex w-[272px] flex-row items-center justify-center space-x-1 rounded-full hover:cursor-pointer ${value === options[1].value ? 'bg-white text-primary' : 'text-graysecondary'} align-middle`}
        >
          {options[0].icon && options[1].icon && (
            <img
              src={options[1].icon}
              alt={`${options[1].value}-svg`}
              className={`h-[20px] w-[20px] ${value === options[1].value ? 'text-primary' : 'text-graysecondary'}`}
            />
          )}{' '}
          <p
            className={`text-center ${isMobile ? 'text-[14px]' : 'text-[16px]'}`}
          >
            {options[1].label}
          </p>
        </div>
      </div>
    );
  }
);

export default CustomToggle;
